// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import echarts from 'echarts'
import moment from 'moment'
import Request from 'src/assets/requestUrl'
import Clipboard from 'clipboard' // 复制到剪切板
import 'src/assets/iconfonts/iconfont.css'
import 'src/assets/iconfonts/iconfont.js'
import Sortable from 'sortablejs'
import VueWechatTitle from 'vue-wechat-title'
import waterfall from 'vue-waterfall2'
import walden from 'src/assets/echartstheme/walden.project'

/*
 * happy-scroll 的使用和参数：
 *  <happy-scroll resize smaller-move-v="start" :min-length-v="10"></happy-scroll>
  * */

Vue.use(HappyScroll)
Vue.use(waterfall)
Vue.use(iView)
Vue.use(VueWechatTitle)
Vue.prototype.$echarts = echarts
echarts.registerTheme('walden', walden) // 注册自定义主题--黑色背景下的主题
Vue.prototype.$moment = moment
// Vue.prototype.$ENV_ENTRY = process.env.ENV_ENTRY // 当前环境项目入口
Vue.prototype.$ENV_ENTRY = 'web' // 当前环境项目入口
Vue.prototype.$Request = Request
Vue.prototype.$clipboard = Clipboard
Vue.prototype.$sortable = Sortable

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 全局的权限校验方法
Vue.prototype.hasAuthorization = function (functionCode, authorizationId) {
  let isSysAdmin = JSON.parse(sessionStorage.getItem('session_isSysAdmin') || localStorage.getItem('session_isSysAdmin'))
  if (isSysAdmin) {
    return true
  }
  let projectFunctionCode = JSON.parse(sessionStorage.getItem('session_projectFunctionCode') || localStorage.getItem('session_projectFunctionCode'))
  if (projectFunctionCode) {
    let authorizationInfo = projectFunctionCode[functionCode]
    if (authorizationId && authorizationInfo) {
      return authorizationInfo.includes(authorizationId)
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/project_web/main.js